@reference "@glow/tailwind-config/reference.css";

.feedback {
  @apply flex;
  @apply justify-between;
  @apply appearance-none;
  @apply rounded-sm;
  @apply font-semibold;
  @apply border;
  @apply border-transparent;
  @apply items-start;
}

.feedback.hasBorder {
  @apply border;
  @apply border-solid;
  @apply border-current;
}

.close {
  @apply px-4;
  @apply pt-4;
  @apply rounded-sm;
  @apply text-inherit;
  @apply bg-inherit;
  @apply border-none;
  @apply cursor-pointer;
}

.content {
  @apply px-4;
  @apply py-3;
  @apply grid;
  @apply gap-2;
  @apply grid-cols-[auto_auto];
}

.content svg:first-of-type {
  @apply mt-1;
}

.feedback.small .content {
  @apply px-3;
  @apply py-2;
}
.feedback.xs .content {
  @apply px-2;
  @apply py-1;
  @apply items-center;
}
.feedback.xs span,
.feedback.xs div {
  @apply text-xs;
  @apply font-bold;
}
.feedback.xs .content svg:first-of-type {
  @apply mt-0;
}

.feedback.noIcon .content {
  @apply grid-cols-[auto];
}

.body {
  @apply col-start-2;
  @apply text-emphasis-high;
  @apply font-normal;
  @apply text-base;
}

.feedback.info-light .body,
.feedback.info-dark .body {
  @apply text-emphasis-medium;
}

.feedback.noIcon .body {
  @apply col-start-1;
}

.feedback.info-light {
  @apply bg-neutral-light;
}

.feedback.info-dark {
  @apply bg-neutral-dark;
  @apply text-neutral-light;
}

.feedback.loading-light,
.feedback.success-light {
  @apply bg-success-light;
  @apply text-success-dark;
}

.feedback.loading-dark,
.feedback.success-dark {
  @apply bg-success-dark;
  @apply text-success-light;
}

.feedback.error-light {
  @apply bg-danger-light;
  @apply text-danger-dark;
}

.feedback.error-dark {
  @apply bg-danger-dark;
  @apply text-danger-light;
}

.feedback.warning-light {
  @apply bg-warning-light;
  @apply text-warning-dark;
}

.feedback.warning-dark {
  @apply bg-warning-dark;
  @apply text-warning-light;
}
